import React, { createContext, useContext, useState, useMemo } from 'react';
import { useUI } from './UIContext';

interface NavigationBadges {
  projetos: number;
  financeiro: number;
  ia: number;
}

interface GlobalFilters {
  companyId?: string | number;
  projectId?: string | number;
  productId?: string | number;
  clientId?: string | number;
  documentId?: string | number;
  ideaId?: string | number;
  memberId?: string | number;
  search?: string;
  dateRange?: string;
  status?: string;
}

interface NavigationContextType {
  badges: NavigationBadges;
  refreshBadges: () => Promise<void>;
  // reuse UIContext's global filter shape (simple search/dateRange/status)
  globalFilters: any;
  setGlobalFilters: React.Dispatch<React.SetStateAction<any>>;
}

const NavigationContext = createContext<NavigationContextType | undefined>(undefined);

export function NavigationProvider({ children }: { children: React.ReactNode }) {
  const { globalFilters, setGlobalFilters } = useUI();
  const [badges] = useState<NavigationBadges>({
    projetos: 3,
    financeiro: 2,
    ia: 5
  });

  const refreshBadges = async () => {};

  const value = useMemo(() => ({
    badges,
    refreshBadges,
    globalFilters,
    setGlobalFilters
  }), [badges, globalFilters, setGlobalFilters]);

  return (
    <NavigationContext.Provider value={value}>
      {children}
    </NavigationContext.Provider>
  );
}

export function useNavigation() {
  const context = useContext(NavigationContext);
  if (context === undefined) {
    throw new Error('useNavigation must be used within a NavigationProvider');
  }
  return context;
}
